var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// libs
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
// stores
import useReadCampaignStore from '@/stores/ReadCampaign';
import useWriteCampaignStore from '@/stores/WriteCampaign';
import useAccountStore from '@/stores/account';
// constants
import { IconCicularLoader } from '@/constants/icons/svg';
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
// includes
import { getCampaignApi } from '@/includes/api/campaign/get';
// widgets
import EditCampaign from './Edit';
// styles
import styles from './Index.module.scss';
import { CampaignStatus } from '@local/typedefs/dist/protos/campaign/Campaign';
const CampaignEditIndexPage = () => {
    const params = useParams();
    const { storedReadCampaign, setReadCampaign } = useReadCampaignStore((state) => ({
        storedReadCampaign: state.campaign,
        setReadCampaign: state.setCampaign,
    }));
    const { setState: setWriteCampaign } = useWriteCampaignStore;
    const getCurrentAccountId = useAccountStore((state) => state.getCurrentAccountId);
    const [campaignToBeEdited, setCampaignToBeEdited] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [isEditable, setIsEditable] = useState(false);
    useEffect(() => {
        !isLoading && !campaignToBeEdited && loadCampaignDetails();
    }, []);
    const setupEditCampaignDetails = (campaignToBeEdited) => {
        const isEditableStatus = campaignToBeEdited.status ===
            CampaignStatus.CAMPAIGN_STATUS_BOOKED ||
            campaignToBeEdited.status === CampaignStatus.CAMPAIGN_STATUS_LIVE;
        setIsEditable(isEditableStatus);
        setCampaignToBeEdited(campaignToBeEdited);
        // have to store cloned campaign to change refrefences
        const clonedCampaign = structuredClone(campaignToBeEdited);
        setReadCampaign(clonedCampaign);
        setWriteCampaign(Object.assign({}, clonedCampaign));
    };
    const fetchCampaignAndSetAsEditCampaign = (campaignId) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setIsLoading(true);
            const accountId = yield getCurrentAccountId();
            const campaign = yield getCampaignApi({ campaignId, accountId });
            if (campaign) {
                setupEditCampaignDetails(campaign);
                setIsLoading(false);
            }
            else {
                setIsError(true);
            }
        }
        catch (_a) {
            setIsError(true);
        }
    });
    const loadCampaignDetails = () => {
        if (!params.id) {
            setIsError(true);
            return;
        }
        if (params.id === (storedReadCampaign === null || storedReadCampaign === void 0 ? void 0 : storedReadCampaign.id)) {
            setupEditCampaignDetails(storedReadCampaign);
        }
        else {
            fetchCampaignAndSetAsEditCampaign(params.id);
        }
    };
    return (React.createElement("div", { className: styles.container },
        isLoading && !isError && (React.createElement("div", { className: styles.containerCenter },
            React.createElement(IconCicularLoader, { height: 108, width: 108, className: styles.loader }),
            React.createElement(Text, { variant: DlsFontVariants.subheader_S1_Reg, color: DlsColorTokens.text_Med_Emphasis }, "Loading Details"))),
        isError && (React.createElement("div", { className: styles.containerCenter },
            React.createElement(Text, { variant: DlsFontVariants.subheader_S1_Bold, color: DlsColorTokens.text_Med_Emphasis }, "Something went wrong!"))),
        campaignToBeEdited && !isEditable && (React.createElement("div", { className: styles.containerCenter },
            React.createElement(Text, { variant: DlsFontVariants.subheader_S1_Bold, color: DlsColorTokens.text_Med_Emphasis }, "Campaign is not editable!"))),
        !isLoading && campaignToBeEdited && !isError && isEditable && (React.createElement(EditCampaign, { currentCampaign: campaignToBeEdited }))));
};
export default CampaignEditIndexPage;
